module.exports = __webpack_public_path__ + "static/Devices-496e607791802b4e3bd4fdd9383b5b56.png";